import './SearchImageResult.scss';
import {  
  CarouselSlider,
} from "@fluentui/react-components";
import {
  Carousel,  
  CarouselCard,
  CarouselNav,
  CarouselNavButton,
  CarouselNavContainer,
  CarouselViewport,
} from "@fluentui/react-components";
import { Text, Card, CardPreview, Image as FImage } from "@fluentui/react-components";



function SearchImageResult({resultlist, searchTriggered})
{
    const results = resultlist;
    const searchHappened = searchTriggered;    

    return(
        <div className='d-flex justify-content-center'>            
            <Carousel draggable>
                <CarouselViewport>
                    <CarouselSlider>
                        {!!results.length && results.map((img) => (
                            <CarouselCard>
                                <Card key={img.id} className="records">
                                    <CardPreview className='d-flex justify-content-center '>
                                        <FImage className="search-result-slider" src={img.src} alt={img.name || img.id} fit="contain"/>
                                    </CardPreview>
                                    <div style={{ padding: 8 }}>
                                        <Text weight="semibold">{img.name || "Result"}</Text>
                                    </div>
                                </Card>
                            </CarouselCard>                        
                        ))}
                        { searchHappened && (results.length === 0) && (
                            <CarouselCard>
                                <div className='d-flex justify-content-center'>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <h5>No records found</h5>
                                        </div>
                                    </div>                                        
                                </div>                                    
                            </CarouselCard>
                        )}                                                
                    </CarouselSlider>
                </CarouselViewport>

                {!!results.length && (<CarouselNavContainer
                    layout="inline"
                    next={{ "aria-label": "go to next" }}
                    prev={{ "aria-label": "go to prev" }}
                >
                <CarouselNav>
                {(index) => (
                    <CarouselNavButton aria-label={`Carousel Nav Button ${index}`} />
                )}
                </CarouselNav>
                </CarouselNavContainer>)}
            </Carousel>            
        </div> 
    );
}

export default SearchImageResult;